module.exports = __webpack_public_path__ + "static/media/whiteDown.9c719028.svg";